// app/api/user.ts
import { User } from "~/utils/interface";
import { request } from "~/utils/request";

/**
 * API 响应基础类型
 */
export interface ApiResponse<T = any> {
  errcode: number;
  errmsg: string;
  data: T;
}

// 获取用户列表
const prefix = "/v1.0/user";
export async function getUserList(params: {
  page?: number;
  pageSize?: number;
  nameSearch?: string;
  phoneFilter?: string;
  roleIdFilter?: string;
}): Promise<ApiResponse<any>> {
  return request(`${prefix}/query/page/list`, {
    method: "POST",
    data: params,
  });
}

// 获取角色列表
export async function getRoleList(data?:{page?: number;pageSize?: number}): Promise<ApiResponse<any>> {
  return request(`${prefix}/get/roles`, {
    method: "GET",
    data,
  });
}

// 创建用户
export async function createUser(data: User): Promise<ApiResponse<any>> {
  return request(`${prefix}/add`, {
    method: "POST",
    data,
  });
}

// 更新用户
export async function updateUser(data: User): Promise<ApiResponse<any>> {
  return request(`${prefix}/update`, {
    method: "POST",
    data,
  });
}
// 删除用户
export async function deleteUser(userId: string): Promise<ApiResponse<any>> {
  return request(`${prefix}/delete`, {
    method: "POST",
    data: { id: userId },
  });
}

export async function getUserDetail(params: {userId:string}): Promise<ApiResponse<User>> {
  return request(`${prefix}/get/detail`, {
    method: "GET",
    params,
  });
}
  
/**
 * 更新密码参数类型
 */
export interface UpdatePasswordParams {
  userName: string;
  phoneNumber: string;
  oldPassword: string;
  newPassword: string;
}

//v1.0/user/update/password
export async function updatePassword(params: UpdatePasswordParams): Promise<ApiResponse<any>> {
  return request(`${prefix}/update/password`, {
    method: "POST",
    data: params,
    // 登录页修改密码不需要登录态，也不能因为未登录被强制跳转
    skipAuth: true,
  });
}

// 转移预览
export async function getTransferPreview(userId: string): Promise<ApiResponse<any>> {
  return request(`${prefix}/transfer/preview`, {
    method: "GET",
    params: { userId },
  });
}

// 执行转移
export async function executeTransfer(fromUserId: string, toUserId: string): Promise<ApiResponse<any>> {
  return request(`${prefix}/transfer/execute`, {
    method: "POST",
    data: { fromUserId, toUserId },
  });
}

//sendUserInfo
export async function sendUserInfo(params: { userId: string }): Promise<ApiResponse<any>> {
  return request(`${prefix}/send/password`, {
    method: "GET",
    params,
  });
}

// 同步企微用户
const qwPrefix = "/v1.0/qw/managed";
export async function syncQwUsers(): Promise<ApiResponse<any>> {
  return request(`${qwPrefix}/sync_from_qw`, {
    method: "POST",
    data: {
      syncResources: [{ qwResourceType: "USER_RESOURCE" }],
    },
  });
}